import { profileSaga } from './profile/profile.saga';
import { customerSaga } from './customer/customer.saga';
import { teamSaga } from './team/team.saga';

export const accountSaga = [...profileSaga, ...customerSaga, ...teamSaga];
